import { render } from "./Paaspop19Project.vue?vue&type=template&id=59171e88&scoped=true"
const script = {}

import "./Paaspop19Project.vue?vue&type=style&index=0&id=59171e88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59171e88"]])

export default __exports__